import { render, staticRenderFns } from "./myWorkbench.vue?vue&type=template&id=23db4f0e&scoped=true"
import script from "./myWorkbench.vue?vue&type=script&lang=js"
export * from "./myWorkbench.vue?vue&type=script&lang=js"
import style0 from "./myWorkbench.vue?vue&type=style&index=0&id=23db4f0e&prod&lang=css"
import style1 from "./myWorkbench.vue?vue&type=style&index=1&id=23db4f0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db4f0e",
  null
  
)

export default component.exports